import React from 'react';
import PropTypes from 'prop-types';
import {
  solarColorArray,
  windColorArray,
  allColorArray,
} from '../styles/colors';
import '../App.css';

import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core / Typography';

const styles = (theme) => ({
  container: {
    position: 'absolute',
    pointerEvents: 'none',
    top: 0,
    right: 0,
    width: '20%',
  },
  energyBar: {
    fontSize: '12px',
    textAlign: 'left',
  },
  colorBox: {
    display: 'flex',
    width: '100%',
    height: '20px',
    backgroundColor: 'darkgrey',
  },
  solarColorBox: {
    backgroundImage: `linear-gradient(to right, ${solarColorArray.join(',')})`,
  },
  windColorBox: {
    backgroundImage: `linear-gradient(to right, ${windColorArray.join(',')})`,
  },
  allColorBox: {
    backgroundImage: `linear-gradient(to right, ${allColorArray.join(',')})`,
  },
});

const getColorBoxClass = (classes) => (currentTech) => {
  if (currentTech.solar && (currentTech.wind || currentTech.windOffshore)) {
    return classes.allColorBox;
  }
  if (currentTech.solar) {
    return classes.solarColorBox;
  }
  return classes.windColorBox;
};

function MapLegend(props) {
  const { classes } = props;
  const colorBoxClassGetter = getColorBoxClass(props.classes);

  return (
    <div className={classes.container}>
      <div className={classes.energyBar + ' darkgrey'}>
        <div style={{ minHeight: '32px' }}>
          Klik een gemeente aan op de kaart
        </div>
        <div
          className={[
            classes.colorBox,
            colorBoxClassGetter(props.currentTech),
          ].join(' ')}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginRight: '0%',
          }}
        >
          <div>0</div>
          <div>
            {props.currentMode === 'realtime'
              ? Math.round(props.maxValue)
              : Math.round(props.maxValue / 1000)}{' '}
            {props.currentMode === 'realtime' ? 'MWh' : 'GWh'}
          </div>
        </div>
      </div>
    </div>
  );
}

MapLegend.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MapLegend);
